import { useTranslation } from 'react-i18next';
import { ArrowUpRightIcon, DownloadIcon } from '@utils/icons';
import { Button } from '@components/ui/Button/Button';
import styles from './DrillDownFooter.module.css';

/** Both actions are placeholders until a report export and the spatial view
 *  exist — shown small and disabled rather than removed. */
export function DrillDownFooter() {
  const { t } = useTranslation();
  return (
    <div className={styles.footer}>
      <Button variant="ghost" size="sm" disabled>
        <DownloadIcon size={14} />
        {t('productivity.drillDown.exportReport')}
      </Button>
      <Button variant="secondary" size="sm" disabled>
        {t('productivity.drillDown.openInSpatial')}
        <ArrowUpRightIcon size={14} />
      </Button>
    </div>
  );
}
